import { render } from "./OneProductIntroComponent.vue?vue&type=template&id=efe5c0fe&scoped=true"
import script from "./OneProductIntroComponent.vue?vue&type=script&lang=js"
export * from "./OneProductIntroComponent.vue?vue&type=script&lang=js"

import "./OneProductIntroComponent.vue?vue&type=style&index=0&id=efe5c0fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe5c0fe"]])

export default __exports__